import { computed, signal, type Signal } from '@angular/core';

export interface CardState {
    cardOpen: Signal<boolean>;
    togglePinned: () => void;
    setTriggerHovered: (isHovered: boolean) => void;
    setCardHovered: (isHovered: boolean) => void;
    setFocusWithin: (isFocused: boolean) => void;
    close: () => void;
}

export function createCardState(hasHiddenItems: Signal<boolean>): CardState {
    const isTriggerHovered = signal(false);
    const isCardHovered = signal(false);
    const isFocusWithin = signal(false);
    const isPinnedOpen = signal(false);

    const cardOpen = computed(() => {
        if (!hasHiddenItems()) {
            return false;
        }

        return (
            isPinnedOpen() ||
            isTriggerHovered() ||
            isCardHovered() ||
            isFocusWithin()
        );
    });

    function togglePinned(): void {
        isPinnedOpen.update((isOpen) => !isOpen);
    }

    function setTriggerHovered(isHovered: boolean): void {
        isTriggerHovered.set(isHovered);
    }

    function setCardHovered(isHovered: boolean): void {
        isCardHovered.set(isHovered);
    }

    function setFocusWithin(isFocused: boolean): void {
        isFocusWithin.set(isFocused);
    }

    function close(): void {
        isPinnedOpen.set(false);
        isTriggerHovered.set(false);
        isCardHovered.set(false);
        isFocusWithin.set(false);
    }

    return {
        cardOpen,
        togglePinned,
        setTriggerHovered,
        setCardHovered,
        setFocusWithin,
        close,
    };
}
